import React from "react";
import ManualSearchPage from "../components/ManualSearchPage";

const ManualSearchPageScreen = () => {
  return <ManualSearchPage />;
};

export default ManualSearchPageScreen;
